import { render, staticRenderFns } from "./privacyAndSecurity.vue?vue&type=template&id=0f4781a0&scoped=true&"
import script from "./privacyAndSecurity.vue?vue&type=script&lang=js&"
export * from "./privacyAndSecurity.vue?vue&type=script&lang=js&"
import style0 from "./privacyAndSecurity.vue?vue&type=style&index=0&id=0f4781a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4781a0",
  null
  
)

export default component.exports